import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ListSubheader from '@mui/material/ListSubheader';
import StyledFormControl from '../StyledComponents/StyledFormControl';
import { useEffect, useState } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ITEM_HEIGHT = 340;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT + ITEM_PADDING_TOP
    }
  }
};

const TierMenu = ({ id, labelId, value, setValue, optionsList }) => {
  const [optionsListByCategory, setOptionsListByCategory] = useState({});

  useEffect(() => {
    let groupByCategory = optionsList.reduce((acc, obj) => {
      let key = obj['resolution'];
      if (!acc[key]) {
        acc[key] = { show: false, values: [] };
      }
      acc[key].values.push({ ...obj });
      return acc;
    }, []);
    setOptionsListByCategory(groupByCategory);
  }, [optionsList]);

  const handleChange = (event) => {
    let foundedValue = optionsList.find((value) => JSON.stringify({ resolution: value.resolution, label: value.label }) === event.target.value);
    setValue({ ...foundedValue });
  };

  const onClickHandler = (resolution) => {
    optionsListByCategory[resolution].show = !optionsListByCategory[resolution].show;
    setOptionsListByCategory({ ...optionsListByCategory });
  };

  if (JSON.stringify(optionsListByCategory) === JSON.stringify({})) {
    return null;
  }

  return (
    <StyledFormControl fullWidth>
      <Select
        style={{ color: value.label === '' ? 'grey' : '' }}
        value={JSON.stringify({ resolution: value.resolution, label: value.label })}
        id={id}
        labelId={labelId}
        onChange={handleChange}
        renderValue={(value) => {
          let valueJson = JSON.parse(value);
          if (valueJson.label === '') return 'Select Tier';
          if (valueJson.label === 'custom') return valueJson.label;
          return `${valueJson.label} - ${valueJson.resolution}`;
        }}
        MenuProps={MenuProps}
      >
        <MenuItem style={{ paddingLeft: '9%' }} value={JSON.stringify({ resolution: '', label: '' })} children={<div>{''}</div>}></MenuItem>
        {Object.keys(optionsListByCategory).map((resolution) => {
          return [
            <ListSubheader
              key={resolution}
              onClick={() => {
                onClickHandler(resolution);
              }}
              style={{ textAlign: 'left' }}
            >
              {optionsListByCategory[resolution].show ? (
                <KeyboardArrowDownIcon style={{ verticalAlign: 'middle' }} />
              ) : (
                <KeyboardArrowRightIcon style={{ verticalAlign: 'middle' }} />
              )}
              {resolution}
            </ListSubheader>,

            optionsListByCategory[resolution].values.map((obj, ind) => {
              return (
                <MenuItem
                  style={{ paddingLeft: '9%', display: optionsListByCategory[resolution].show ? '' : 'none' }}
                  key={resolution + obj.label + ind}
                  value={JSON.stringify({ resolution: obj.resolution, label: obj.label })}
                  children={<div> {obj.label}</div>}
                ></MenuItem>
              );
            })
          ];
        })}
      </Select>
    </StyledFormControl>
  );
};
export default TierMenu;
